
import { Consent } from '../../api/consent';
import { sanitizeHtml } from '../../helpers/sanitizeHtml';
import CheckboxField from '../CheckboxField/CheckboxField';
import { ConsentCheckboxContent, ConsentCheckboxContentWrapper } from './ConsentField.styles';

type Props = {
    consentDetail: Consent;
    defaultChecked?: boolean;
};

const ConsentCheckbox = ({ consentDetail, defaultChecked }: Props) => {
    return (
        <>
            <CheckboxField name={consentDetail.name} label={consentDetail.label} defaultChecked={defaultChecked} />
            {consentDetail.information && (
                <ConsentCheckboxContentWrapper>
                    <ConsentCheckboxContent
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(consentDetail.information) }}
                    />
                </ConsentCheckboxContentWrapper>
            )}
        </>
    );
};

export default ConsentCheckbox;
